import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { appUserDataHandlers, appUserDataInitialState, appUserDataReducer } from '../reducers/AppUserDataReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';

/** Global Conversations for the Event */
export const AppUserDataContext = createContext();

/** Global Conversations for the Event */
const AppUserDataProvider = (props) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appUser_state, page_state, paps_state, currentSettings_state } = states

  const { appUser, appUsers } = appUser_state ?? {}
  const { pathViews, showStatus } = paps_state ?? {}
  const appUserAccess = useAppUserAccess()
  const { uid } = appUserAccess ?? {}

  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});

  // local state
  const initState = appUserDataInitialState(appUserAccess, appUser, appUsers, paps_state, page_state, aps_appUserSettings)
  const [appUserData_state, appUserData_dispatch] = useReducer(appUserDataReducer, initState);
  const { conversations, notes } = appUserData_state

  const appUserData_handlers = useMemo(
    () => appUserDataHandlers(appUserData_dispatch),
    [appUserData_dispatch]
  );

  if (showStatus && (conversations || notes)) { console.log('conversation_state ready', appUserData_state) }

  useEffect(
    () => {
      if (appUser.loggedIn && pathViews && pathViews.events) {
        appUserData_handlers.handleGet_conversations(paps_state)
        appUserData_handlers.handleGetNotes(paps_state)
      } else {
        appUserData_handlers.handleLoadConversations({})
        appUserData_handlers.handleLoadNotes({})
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathViews.events, uid] // does not re-rednder unless uivi has changed
  )

  const providerContext = () => <AppUserDataContext.Provider value={{ appUserData_state, appUserData_handlers, appUser }}>
    {props.children}
  </AppUserDataContext.Provider>

  return (
    <React.Fragment>
      {(conversations && notes) && providerContext(conversations)}
    </React.Fragment>
  )
}

export default AppUserDataProvider